<template>
  <v-popover
    placement="top"
    content-tag="div"
    class="flex"
    tag="div"
    :on-show="() => !!props.tooltip && !isMobile"
  >
    <div
      ref="menuButton"
      class="toolbar-menu-item"
    >
      <slot>
        <button
          class="min-w-6"
          :class="{
            'disabled-toolbar-option': props.disabled,
            'is-active': props.active,
          }"
          @click="props.effect"
        >
          <em
            v-if="props.icon"
            class="custom-icons page-toolbar group-hover:bg-icon-hover"
            :class="{ 'ml-1': props.label }"
            :style="getCustomIconStyle(iconPath(props.icon))"
          />
          <span
            v-if="props.label"
            class="text-text-default ml-1 text-sm"
            :class="{ 'mr-1': props.label }"
            >{{ props.label }}</span
          >
        </button>
      </slot>
    </div>
    <template #content="{ state }">
      <TooltipTemplate
        v-if="state.isVisible"
        :tooltip-text="props.tooltip"
        :tooltip-meta="props.meta"
      />
    </template>
  </v-popover>
</template>

<script setup lang="ts">
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import TooltipTemplate from '@/components/elements/TooltipTemplate.vue';

const props = defineProps<{
  effect: CallableFunction;
  icon: string;
  tooltip?: string;
  meta?: Record<string, any>;
  parentProps?: Record<string, any>;
  disabled?: boolean;
  active?: boolean;
  label?: string;
}>();

const { iconPath, getCustomIconStyle } = useCustomIcon();
</script>

<style lang="scss" scoped>
button {
  &.disabled-toolbar-option {
    user-select: none;
    pointer-events: none;
    .custom-icons {
      @apply bg-inactive-icon;
    }
  }
}
</style>
